import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, icon, trend, trendUp, subtitle, color = 'primary', prefix = '', suffix = '' }) => {
  const colorMap = {
    primary: 'bg-primary/10 text-primary',
    green: 'bg-green-100 text-green-600',
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    orange: 'bg-orange-100 text-orange-600',
    red: 'bg-red-100 text-red-600',
  };

  return (
    <div className="bg-card border border-border rounded-lg p-5 hover:shadow-md transition-smooth">
      <div className="flex items-center justify-between mb-3">
        <div className={`p-2 rounded-md ${colorMap?.[color] || colorMap?.primary}`}>
          <Icon name={icon} size={20} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 text-xs font-medium ${
            trendUp ? 'text-green-600' : 'text-red-600'
          }`}>
            <Icon name={trendUp ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{trend}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-2xl font-bold text-foreground mb-0.5">
          {prefix}{typeof value === 'number' ? value?.toLocaleString() : (value || 0)}{suffix}
        </p>
        <p className="text-sm text-muted-foreground">{title}</p>
        {subtitle && (
          <p className="text-xs text-muted-foreground/70 mt-1">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default StatsCard;